var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-6",staticStyle:{"width":"100%"},attrs:{"id":"group-locations"}},[_c('locations',{attrs:{"_deviceLocations":_vm.groupLocations,"centerLocation":{ lat: _vm.details.lat, lng: _vm.details.lng },"isScreen":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }